// Approving an agent's change is never one click: the button asks again,
// naming the change and whether it applies on the panel now.
import React from "react";
import { Popconfirm } from "antd";
import { toDisplayBrand } from "../../utils/displayBrand";
import { FIG_MUTED } from "../../design";

const ApproveConfirm = ({ change, live, onConfirm, children }) => (
  <Popconfirm
    placement="bottomRight"
    overlayStyle={{ maxWidth: 380 }}
    title="Approve this change?"
    description={(
      <div style={{ fontSize: 13, lineHeight: 1.5 }}>
        {change ? <div style={{ fontWeight: 600, marginBottom: 4 }}>{toDisplayBrand(change)}</div> : null}
        <div style={{ color: FIG_MUTED }}>{live ? "It applies on the panel as soon as you confirm." : "Nothing changes on the panel: it is recorded as a simulation."}</div>
      </div>
    )}
    okText="Yes, approve"
    cancelText="Cancel"
    onConfirm={onConfirm}>
    {children}
  </Popconfirm>
);

export default ApproveConfirm;
